import React from 'react';
import { Info } from 'lucide-react';
import { PERFORMANCE_DISCLAIMERS } from '../../data/ipoPerformanceData';

export const PerformanceDisclaimers = ({ asOf }) => (
  <section aria-labelledby="performance-disclaimers-heading" className="rounded-2xl border border-amber-200 bg-amber-50/70 p-4 sm:p-5">
    <h2 id="performance-disclaimers-heading" className="flex items-center gap-2 text-xs sm:text-sm font-bold text-slate-900">
      <Info className="w-4 h-4 text-amber-600 shrink-0" aria-hidden="true" />
      Important Calculation &amp; Statutory Disclaimers:
    </h2>
    <ul className="mt-2.5 pl-6 list-disc space-y-1.5 text-xs text-slate-600 leading-relaxed marker:text-slate-400">
      {PERFORMANCE_DISCLAIMERS.map((line) => (
        <li key={line}>{line}</li>
      ))}
      <li>Information on this page is current as of {asOf} (End of Day).</li>
    </ul>
  </section>
);

export default PerformanceDisclaimers;
